import React from "react";

function AMMDexHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Automated Market Maker (AMM) DEX Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology offers comprehensive development services
                    for Automated Market Maker (AMM) DEX platforms, empowering
                    DeFi projects to provide users with seamless, peer-to-peer
                    trading experiences without the need for traditional order
                    books.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AMMDexHero;
